import React from "react";
import { UtensilsCrossed, Zap, PartyPopper, Users, Droplets, Toilet } from "lucide-react";

const META = {
  hunger: { label: "Hunger", color: "#FFD700", icon: UtensilsCrossed },
  energy: { label: "Energy", color: "#16A34A", icon: Zap },
  fun: { label: "Fun", color: "#FF0055", icon: PartyPopper },
  social: { label: "Social", color: "#FF66B2", icon: Users },
  hygiene: { label: "Hygiene", color: "#00E5FF", icon: Droplets },
  bladder: { label: "Bladder", color: "#A78BFA", icon: Toilet },
};

const ORDER = ["hunger", "energy", "fun", "social", "hygiene", "bladder"];

export default function NeedsHUD({ needs }) {
  if (!needs) return null;
  return (
    <div className="grid grid-cols-3 gap-2" data-testid="needs-hud">
      {ORDER.map((k) => {
        const m = META[k];
        const val = Math.round(needs[k] ?? 0);
        const low = val <= 20;
        const Icon = m.icon;
        return (
          <div
            key={k}
            data-testid={`need-${k}`}
            className="bg-white border border-slate-200 rounded-lg p-2"
          >
            <div className="flex items-center justify-between mb-1.5">
              <Icon size={13} style={{ color: m.color }} className={low ? "pulse-danger" : ""} />
              <span className="label-xs text-slate-500">{m.label}</span>
            </div>
            <div className="h-1.5 rounded-full bg-black/60 overflow-hidden">
              <div
                className="h-full rounded-full transition-[width] duration-500"
                style={{
                  width: `${val}%`,
                  background: m.color,
                  boxShadow: `0 0 8px ${m.color}`,
                }}
              />
            </div>
            <div className={`mt-1 text-[0.7rem] font-semibold ${low ? "text-[#FF0055] pulse-danger" : "text-slate-500"}`}>
              {val}%
            </div>
          </div>
        );
      })}
    </div>
  );
}
